import { Box, SimpleGrid, Text } from '@chakra-ui/react';

import DetailSelloutCard from '../sellout/card';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';

export default function GeneralInfo() {
    const { selectedAuditTrail } = useMainState();

    console.log(selectedAuditTrail);
    const infoData = [
        {
            title: 'Customer ID',
            content: <Text>{selectedAuditTrail?.customer_id ?? '-'}</Text>,
        },
        {
            title: 'Customer',
            content: <Text>{selectedAuditTrail?.nama_outlet ?? '-'}</Text>,
        },
        {
            title: 'Distribution Center',
            content: <Text>{selectedAuditTrail?.nama_dc ?? '-'}</Text>,
        },
        {
            title: 'Store Group ID',
            content: <Text>{selectedAuditTrail?.store_group_id ?? '-'}</Text>,
        },
        {
            title: 'Store Group',
            content: <Text>{selectedAuditTrail?.group ?? '-'}</Text>,
        },
        {
            title: 'External Reference',
            content: <Text>{selectedAuditTrail?.sap_customer_id ?? '-'}</Text>,
        },
    ];

    return (
        <Box>
            <SimpleGrid columns={3} spacing={4}>
                {infoData.map((item, index) => (
                    <DetailSelloutCard key={index} {...item} />
                ))}
            </SimpleGrid>
        </Box>
    );
}
